<app-form-loading-screen *ngIf="showSelfLoader"></app-form-loading-screen>
<span *ngIf="loading">{{ 'Loading' | translate }}...</span>
<div class="tileDataBox">
  <div class="w-full flex flex-col contentBox">
    <div class="w-full flex flex-col gap-[20px] pt-2">
      <div class="flex flex-row gap-[20px] form-lib-meta-row">
        <div class="flex-[25%] form-lib-meta-field">
          <mat-form-field class="w-full">
            <mat-label>{{ 'Title' | translate }}</mat-label>
            <input matInput #title name="title" [(ngModel)]="selectedData.title" [required]="true"
              placeholder="{{ 'Title' | translate }}" [errorStateMatcher]="esMatcher" max="200" maxlength="200">
            <mat-error *ngIf="selectedData.title === undefined || selectedData.title === ''">
              {{ 'Title' | translate }} is required.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex-[25%] form-lib-meta-field">
          <app-custom-select-create-autocomplete class="not-padding-input" [value]="selectedData.category"
            [orgId]="selectedOrganization" [dataType]="'category'" [dataTypeDisplay]="'Category'"
            [placeholder]="'Select / Add Category'" [useOrg]="true" [canDelete]="true"
            (onSelectReturn)="handleTileDataSelectReturn($event)" [type]="'tile'" [onBlur]="true">
          </app-custom-select-create-autocomplete>
        </div>
        <div class="flex-[100%] form-lib-meta-field form-lib-flag-field" *ngIf="hasFlagType">
          <mat-form-field class="w-full">
            <mat-label>{{ "Flag" | translate }}</mat-label>
            <mat-select (selectionChange)="selectedData.flag = $event.value" [value]="selectedData.flag">
              <mat-option *ngFor="let itm of flagMeta.enum" [value]="itm.value">{{ itm.displayName }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Mobile-only: top actions as one dropdown (desktop buttons unchanged) -->
        <div class="mobile-form-lib-actions" *ngIf="!isDialog">
          <button mat-raised-button color="primary" type="button" [matMenuTriggerFor]="mobileFormActionsMenu">
            <mat-icon>more_vert</mat-icon>
            {{ 'Actions' | translate }}
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #mobileFormActionsMenu="matMenu">
            <button mat-menu-item type="button" (click)="toggleClick('new')">
              <mat-icon>add</mat-icon>
              <span>{{ 'New' | translate }}</span>
            </button>
            <button mat-menu-item type="button" (click)="toggleClick('save')">
              <mat-icon>save</mat-icon>
              <span>{{ 'Save' | translate }}</span>
            </button>
            <button mat-menu-item type="button" (click)="toggleClick('duplicate')">
              <mat-icon>content_copy</mat-icon>
              <span>{{ 'Duplicate' | translate }}</span>
            </button>
            <button mat-menu-item type="button" (click)="toggleClick('preview')"
              [disabled]="!selectedData.hasOwnProperty('_id')">
              <mat-icon>visibility</mat-icon>
              <span>{{ 'Preview' | translate }}</span>
            </button>
            <button mat-menu-item type="button" (click)="toggleClick('delete')"
              [disabled]="!selectedData.hasOwnProperty('_id')">
              <mat-icon>delete</mat-icon>
              <span>{{ 'Delete' | translate }}</span>
            </button>
          </mat-menu>
        </div>

        <div class="flex-[50%] topBtns desktop-form-lib-actions" *ngIf="!isDialog">
          <!-- <button *ngIf="!isDialog && isAdmin" color="secondary" mat-raised-button
                (click)="toggleClick('designer')">{{ 'Designer' | translate }}</button> -->
          <button color="primary" mat-flat-button (click)="toggleClick('delete')"
            [disabled]="!selectedData.hasOwnProperty('_id')">{{ 'Delete' | translate }}</button>
          <button color="primary" mat-flat-button (click)="toggleClick('preview')"
            [disabled]="!selectedData.hasOwnProperty('_id')">{{ 'Preview' | translate }}</button>
          <!-- <button *ngIf="!isDialog" color="primary" mat-raised-button (click)="toggleClick('Newpreview')" [disabled]="!selectedData.hasOwnProperty('_id')">{{ 'Preview' | translate }}</button> -->
          <button color="primary" mat-flat-button (click)="toggleClick('duplicate')">{{
            'Duplicate' | translate }}</button>
          <button color="primary" mat-flat-button (click)="toggleClick('save')">{{ 'Save' |
            translate }}</button>
          <button color="primary" mat-flat-button (click)="toggleClick('new')">{{ 'New' |
            translate }}</button>
        </div>
      </div>
      <div class="flex-[100%] form-lib-options-wrap" style="margin-bottom: 1vh;">
        <div class="flex flex-row gap-[20px] form-lib-options-row">
          <div class="flex-[25%]" *ngIf="hasTypeField">
            <mat-form-field class="w-full">
              <mat-label>{{"Type" | translate}}</mat-label>
              <mat-select #tileType ng-model="tileType" [disabled]="!isSuperAdmin"
                (selectionChange)="setAttribute('tileType', $event.value)" [value]="selectedData.tileType">
                <mat-option *ngFor="let itm of typeMeta.enum" [value]="itm.value">
                  {{itm.displayName | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex-[25%]" *ngIf="enablePaidContent">
            <mat-form-field class="w-full">
              <mat-label>{{"Paid Content" | translate}}</mat-label>
              <mat-select #subscriptionType ng-model="subscriptionType" [disabled]="!isSuperAdmin"
                (selectionChange)="setAttribute('subscriptionType', $event.value)"
                [value]="selectedData.subscriptionType">
                <mat-option *ngFor="let itm of paidContentMeta.enum" [value]="itm.value">
                  {{itm.displayName | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex-[25%]">
            <mat-checkbox [matTooltip]="'Check to enforce submitting the sections in order' | translate"
              [(ngModel)]="selectedData.enforceOrder">{{'Enforce Section Order' |
              translate}}</mat-checkbox>
          </div>
          <div class="flex-[25%]" *ngIf="enableAddAssessments">
            <mat-checkbox [matTooltip]="'Check to show this tile in assessments' | translate"
              [(ngModel)]="selectedData.showInAssessments">{{'Show in Assessments' |
              translate}}</mat-checkbox>
          </div>
        </div>
        <div class="flex flex-row gap-[20px] form-lib-options-row" *ngIf="selectedData.tileType === 'safe_app_content'" style="margin-top: 1vh;">
          <div class="flex-[25%]">
            <app-custom-select-create-autocomplete class="not-padding-input" [value]="selectedData.resourceType"
              [orgId]="selectedOrganization" [dataType]="'category'" [dataTypeDisplay]="'Resource type'"
              [placeholder]="'Select / Add Resource type'" [useOrg]="true" [canDelete]="true" [maxLength]="100"
              (onSelectReturn)="handleResourceTypeSelectReturn($event)" [type]="'resourceType'" [onBlur]="true">
            </app-custom-select-create-autocomplete>
          </div>
          <div class="flex-[25%]">
            <mat-form-field class="w-full">
              <mat-label>{{ 'Duration' | translate }}</mat-label>
              <input matInput name="duration" [(ngModel)]="selectedData.duration" maxlength="100"
                placeholder="{{ 'Duration' | translate }}">
              <mat-hint align="end">{{ selectedData.duration?.length || 0 }}/100</mat-hint>
            </mat-form-field>
          </div>
          <div class="flex-[25%]">
          </div>
          <div class="flex-[25%]" *ngIf="enableAddAssessments">
          </div>
        </div>
      </div>
      <!-- </mat-card-content>
              </mat-card> -->
    </div>
  </div>
  <div class="flex flex-col lg:flex-row gap-[20px]">
    <!-- Mobile-only: widgets dropdown + content list toggle (desktop unchanged) -->
    <div class="mobile-form-lib-toolbar" *ngIf="!isDialog">
      <button mat-raised-button color="primary" type="button" [matMenuTriggerFor]="mobileWidgetsMenu">
        <mat-icon>widgets</mat-icon>
        {{ 'Widgets' | translate }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #mobileWidgetsMenu="matMenu" class="mobile-widgets-menu">
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'text', {}, 'Editor', false, true)">
          {{ 'Editor' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'startwrapper', {}, 'Start Wrapper', false, true)">
          {{ 'Start Wrapper' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'questionnaire', {}, 'Cascading Questionnaire', false, true)">
          {{ 'Cascading Questionnaire' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'painlevel', {}, 'Pain Level', false, true)">
          {{ 'Pain Level' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'survey', {}, 'Simple Questionnaire', false, true)">
          {{ 'Simple Questionnaire' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'questions', {}, 'Q&A', false, true)">
          {{ 'Q&A' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'inquiry', {}, 'Inquiry', false, true)">
          {{ 'Inquiry' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'endwrapper', {}, 'End Wrapper', false, true)">
          {{ 'End Wrapper' | translate }}
        </button>
        <button mat-menu-item type="button"
          (click)="loadWidgets($event, 'linkdescription', {}, 'Link with Description', false, true)">
          {{ 'Link with Description' | translate }}
        </button>
      </mat-menu>

      <button mat-raised-button color="primary" type="button"
        (click)="openMobileContentList()">
        <mat-icon>list</mat-icon>
        {{ UIDisplay | translate }} {{ 'List' | translate }}
      </button>
    </div>

    <div class="lg:min-w-[fit-content] lg:max-w-[fit-content] flex-[25%] desktop-widgets">
      <mat-card class="example-card widgetList">
        <mat-card-header>
          <div class="flex flex-row gap-[0px]">
            <div class="flex-[80%]">
              <mat-card-title>{{ 'Widgets' | translate }}</mat-card-title>
            </div>
            <div class="flex-[20%]">
              <button mat-icon-button align="end" style="visibility: hidden;">
                Temp
              </button>
            </div>
          </div>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content>
          <div class='widget-basic-collapse'>
            <div id='widgetEditor' block='Text' data-placement='top'
              title="{{'Add any description in multiple paragraphs.' | translate}}" class='widget_btn'
              (click)='loadWidgets($event, "text", {}, "Editor", false, true)'>
              <!-- <div>
                        <img src='/assets/img/text_32.png' />
                      </div> -->
              <div>
                <label>{{ 'Editor' | translate }}</label>
              </div>
            </div>
            <div id='widgetstartWrapper' block='startwrapper' data-toggle='tooltip' title='' class='widget_btn'
              (click)='loadWidgets($event, "startwrapper", {}, "Start Wrapper", false, true)'>
              <!-- <div>
                        <img  src='/assets/img/inquery.png' />
                      </div> -->
              <div>
                <label>{{ 'Start Wrapper' | translate }}</label>
              </div>
            </div>
            <div id='widgetQuestionnaire' block='questionnaire' data-toggle='tooltip' data-toggle='tooltip'
              title="{{'Multiple questions where users can select only One or Multiple answers.  Percentages can be shown in-app.' | translate}}"
              class='widget_btn'
              (click)='loadWidgets($event, "questionnaire", {}, "Cascading Questionnaire", false, true)'>
              <!-- <div>
                        <img
                          src='/assets/img/survey.png' />
                      </div> -->
              <div>
                <label>{{ 'Cascading Questionnaire' | translate }}</label>
              </div>
            </div>
            <div id='widgetpainlevel' block='painlevel' data-toggle='tooltip' title='Denotes pain level'
              class='widget_btn' (click)='loadWidgets($event, "painlevel", {}, "Pain Level", false, true)'>
              <!-- <div>
                        <img  src='/assets/img/inquery.png' />
                      </div> -->
              <div>
                <label>{{ 'Pain Level' | translate }}</label>
              </div>
            </div>
            <div id='widgetsurvey' block='survey' data-toggle='tooltip'
              title='Multiple questions where users can select only One or Multiple answers.  Percentages can be shown in-app.'
              class='widget_btn' (click)='loadWidgets($event, "survey", {}, "Simple Questionnaire", false, true)'>
              <!-- <div>
                        <img  src='/assets/img/inquery.png' />
                      </div> -->
              <div>
                <label>{{ 'Simple Questionnaire' | translate }}</label>
              </div>
            </div>
            <div id='widgetQandA' block='questions' data-toggle='tooltip' data-toggle='tooltip'
              title="{{'One or more questions requiring users to type their answers.' | translate}}" class='widget_btn'
              (click)='loadWidgets($event, "questions", {}, "Q&A", false, true)'>
              <div>
                <label>{{ 'Q&A' | translate }}</label>
              </div>
            </div>
            <div id='widgetInquiry' block='inquiry' data-toggle='tooltip'
              title='Add Inquiry at the bottom of a Tile to allow users to send inquiries about the subject discussed in that Tile. Inquiries are directed to the email entered in the Tile.'
              class='widget_btn' (click)='loadWidgets($event, "inquiry", {}, "Inquiry", false, true)'>
              <!-- <div>
                        <img  src='/assets/img/inquery.png' />
                      </div> -->
              <div>
                <label>{{ 'Inquiry' | translate }}</label>
              </div>
            </div>
            <div id='widgetendWrapper' block='endwrapper' data-toggle='tooltip' title='' class='widget_btn'
              (click)='loadWidgets($event, "endwrapper", {}, "End Wrapper", false, true)'>
              <!-- <div>
                        <img  src='/assets/img/inquery.png' />
                      </div> -->
              <div>
                <label>{{ 'End Wrapper' | translate }}</label>
              </div>
            </div>
            <div id='widgetLinkdescription' block='linkDescription' data-toggle='tooltip'
              title="{{ 'Link with Description' | translate }}" class='widget_btn'
              (click)='loadWidgets($event, "linkdescription", {}, "Link with Description", false, true)'>
              <div>
                <label>{{ 'Link with Description' | translate }}</label>
              </div>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <!-- <button mat-raised-button>LIKE</button>
                  <button mat-raised-button>SHARE</button> -->
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="flex flex-col lg:flex-row gap-[20px] w-full">
      <div class="flex-100" *ngIf="isDialog">
        <mat-card class="tileData">
          <mat-card-header>
            <div class="flex flex-row gap-[0px] w-full">
              <div class="flex-80">
                <mat-card-title>{{UIDisplay | translate}} {{'Data' | translate}} </mat-card-title>
              </div>
              <div class="justify-end">
                <button mat-icon-button (click)="collapseAllWidget()" *ngIf="!collapseOnload" title="Collapse All">
                  <mat-icon>unfold_less</mat-icon>
                </button>
                <button mat-icon-button (click)="unCollapseAllWidget()" title="Expand All" *ngIf="collapseOnload">
                  <mat-icon>unfold_more</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content style="max-height: 80vh;overflow: auto;">
            <div *ngFor="let subItem of blocks;let index = index">
              <div class="widgetAdd" [class.widgetAddSelected]="selectedIndex === index" (click)="widgetAdd(index)">
                <!-- <div class="widgetBorder"></div> -->
                <mat-icon class="widgetAddIcon" *ngIf="selectedIndex !== index">
                  add_circle</mat-icon>
                <mat-icon class="widgetAddIcon" *ngIf="selectedIndex === index">cancel
                </mat-icon>
                <div class="widgetAddText" *ngIf="selectedIndex === index">Click on a widget to add it to this space
                </div>
              </div>
              <mat-card class="example-card" *ngIf="subItem">
                <mat-card-header [class.collapseHead]="subItem.collapse" (click)="collapseWidgetTouch(index)">
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title>{{subItem.blockName | translate}}</mat-card-title>
                  <div class="flex-1" style="text-align: center;overflow: hidden;margin-top: 10px;position: relative;">
                    <div class="flex flex-row gap-[2px]" *ngIf="subItem.type === 'startwrapper'">
                      <div class="flex-[80%]">
                        <span title="{{subItem.data && subItem.data.title ? subItem.data.title: ''}}"
                          class="startwrapperTitle" *ngIf="subItem.data && subItem.data.title">
                          {{subItem.data.title}}
                        </span>
                      </div>
                      <div class="flex-[20%]">
                        <span class="startwrapperColor" *ngIf="subItem.data && subItem.data.color"
                          [ngStyle]="{'background-color': subItem.data && subItem.data.color ? subItem.data.color : '#000000'}"></span>
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-center items-center">
                    <button [disabled]="index === 0" mat-icon-button (click)="moveSubData($event,true, index)">
                      <mat-icon>keyboard_arrow_up</mat-icon>
                    </button>
                    <button [disabled]="index === blocks.length-1" mat-icon-button
                      (click)="moveSubData($event,false, index)">
                      <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeWidget($event,index)">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <!-- <button mat-icon-button (click)="deleteWidget(index)" *ngIf="subItem.activate">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button mat-icon-button (click)="unDeleteWidget(index)" *ngIf="!subItem.activate">
                          <mat-icon>visibility_off</mat-icon>
                        </button> -->
                    <button mat-icon-button (click)="collapseWidget($event, index)" *ngIf="subItem.collapse"
                      title="Expand">
                      <mat-icon>unfold_more</mat-icon>
                    </button>
                    <button mat-icon-button (click)="unCollapseWidget($event, index)" *ngIf="!subItem.collapse"
                      title="Collapse">
                      <mat-icon>unfold_less</mat-icon>
                    </button>
                  </div>
                </mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content [hidden]="subItem.collapse">
                  <app-widget [isVisible]="!subItem.collapse" [title]="subItem.blockName" [type]="subItem.type"
                    [data]="subItem" [tileType]="selectedData.tileType" [needsEnum]="possibleNeedsEnum"
                    (onActionData)="actionData(index, $event)"></app-widget>
                </mat-card-content>
              </mat-card>
            </div>
            <!-- <div class="widgetAdd" [class.widgetAddSelected]="selectedIndex == undefined"
                  (click)="widgetAdd(undefined)">
                  <mat-icon class="widgetAddIcon">
                    add_circle</mat-icon>
                </div> -->
          </mat-card-content>
        </mat-card>
      </div>
      <div class="flex-[75%]" *ngIf="!isDialog">
        <mat-card class="tileData">
          <mat-card-header>
            <div class="flex flex-row gap-[0px] w-full">
              <div class="flex-[80%]">
                <mat-card-title>{{UIDisplay | translate}} {{'Data' | translate}} </mat-card-title>
              </div>
              <div class="justify-end">
                <button mat-icon-button (click)="collapseAllWidget()" *ngIf="!collapseOnload" title="Collapse All">
                  <mat-icon>unfold_less</mat-icon>
                </button>
                <button mat-icon-button (click)="unCollapseAllWidget()" title="Expand All" *ngIf="collapseOnload">
                  <mat-icon>unfold_more</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content style="max-height: 80vh;overflow: auto;">
            <div *ngFor="let subItem of blocks;let index = index">
              <div class="widgetAdd" [class.widgetAddSelected]="selectedIndex === index" (click)="widgetAdd(index)">
                <!-- <div class="widgetBorder"></div> -->
                <mat-icon class="widgetAddIcon" *ngIf="selectedIndex !== index">
                  add_circle</mat-icon>
                <mat-icon class="widgetAddIcon" *ngIf="selectedIndex === index">cancel
                </mat-icon>
                <div class="widgetAddText" *ngIf="selectedIndex === index">Click on a widget to add it to this space
                </div>
              </div>
              <mat-card class="example-card" *ngIf="subItem">
                <mat-card-header [class.collapseHead]="subItem.collapse" (click)="collapseWidgetTouch(index)">
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title>{{subItem.blockName | translate}}</mat-card-title>
                  <div class="flex-1" style="text-align: center;overflow: hidden;margin-top: 10px;position: relative;">
                    <div class="flex flex-row gap-[2px]" *ngIf="subItem.type === 'startwrapper'">
                      <div class="flex-[80%]">
                        <span title="{{subItem.data && subItem.data.title ? subItem.data.title: ''}}"
                          class="startwrapperTitle" *ngIf="subItem.data && subItem.data.title">
                          {{subItem.data.title}}
                        </span>
                      </div>
                      <div class="flex-[20%]">
                        <span class="startwrapperColor" *ngIf="subItem.data && subItem.data.color"
                          [ngStyle]="{'background-color': subItem.data && subItem.data.color ? subItem.data.color : '#000000'}"></span>
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-center items-center">
                    <button [disabled]="index === 0" mat-icon-button (click)="moveSubData($event, true, index)">
                      <mat-icon>keyboard_arrow_up</mat-icon>
                    </button>
                    <button [disabled]="index === blocks.length-1" mat-icon-button
                      (click)="moveSubData($event, false, index)">
                      <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeWidget($event,index)">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <!-- <button mat-icon-button (click)="deleteWidget(index)" *ngIf="subItem.activate">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        <button mat-icon-button (click)="unDeleteWidget(index)" *ngIf="!subItem.activate">
                          <mat-icon>visibility_off</mat-icon>
                        </button> -->
                    <button mat-icon-button (click)="collapseWidget($event, index)" *ngIf="subItem.collapse"
                      title="Expand">
                      <mat-icon>unfold_more</mat-icon>
                    </button>
                    <button mat-icon-button (click)="unCollapseWidget($event, index)" *ngIf="!subItem.collapse"
                      title="Collapse">
                      <mat-icon>unfold_less</mat-icon>
                    </button>
                  </div>
                </mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content [hidden]="subItem.collapse">
                  <app-widget [isVisible]="!subItem.collapse" [title]="subItem.blockName" [type]="subItem.type"
                    [data]="subItem" [tileType]="selectedData.tileType" [needsEnum]="possibleNeedsEnum"
                    (onActionData)="actionData(index, $event)"></app-widget>
                </mat-card-content>
              </mat-card>
            </div>
            <!-- <div class="widgetAdd" [class.widgetAddSelected]="selectedIndex == undefined"
                  (click)="widgetAdd(undefined)">
                  <div class="widgetBorder"></div>
                  <mat-icon class="widgetAddIcon">
                    add_circle</mat-icon>
                </div> -->
          </mat-card-content>
        </mat-card>
      </div>
      <div class="flex-[25%] content-list max-w-[25%]" *ngIf="!isDialog"
        [class.mobile-content-list-open]="showMobileContentList">
        <div class="mobile-content-list-sheet-header">
          <span class="mobile-content-list-sheet-title">
            {{ UIDisplay | translate }} {{ 'List' | translate }}
          </span>
          <button mat-icon-button type="button" (click)="closeMobileContentList()"
            [attr.aria-label]="'Close' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="mobile-content-list-sheet-body">
          <app-tiles-list #tileList [selectedData]="selectedData" (tileAction)="tileActionReturn($event)"
            (selectItem)="selectItemCheck($event)" [hasCategories]="true" [canDelete]="true"
            [enablePaidContent]="enablePaidContent" [hasTypeField]="hasTypeField" [isSuperAdmin]="isSuperAdmin"
            [typeMeta]="typeMeta" [paidContentMeta]="paidContentMeta"></app-tiles-list>
        </div>
      </div>
    </div>
  </div>
</div>